<template>
  <v-tooltip top style="width: 300px">
    <template v-slot:activator="{ on }">
      <v-chip :href="href" target="_blank" v-bind="$attrs" v-on="on">
        <Icon left>{{ icon }}</Icon>
        {{ displayTitle }}
      </v-chip>
    </template>
    <span>{{ value == displayTitle ? href : value }}</span>
  </v-tooltip>
</template>
<script>
import { defineComponent } from "vue";
import { mailto } from "common/utils/helper.js";

export default defineComponent({
  name: "EmailChip",

  props: {
    value: { type: String, default: "" },
    title: { type: String, default: "" },
    icon: { type: String, default: "mdi-email" },
  },
  data() {
    return {
      href: "",
    };
  },
  watch: {
    async value() {
      this.href = await mailto(this.value);
    },
  },
  computed: {
    displayTitle() {
      return this.title || this.value;
    },
  },
  async created() {
    this.href = await mailto(this.value);
  },
});
</script>
